export function initExternalLinks() {
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const link = target.closest('a');

    if (!link || !link.href) return;

    // Try to parse the URL to securely check the hostname
    try {
      const url = new URL(link.href);
      const isExternal = url.hostname !== window.location.hostname;
      const isPDF = url.href.endsWith('.pdf');

      // Ignore mailto:, tel:, javascript: etc.
      const isHttp = url.protocol === 'http:' || url.protocol === 'https:';

      if ((isExternal || isPDF) && isHttp) {
        link.setAttribute('target', '_blank');
        // Prevent reverse tabnabbing attacks
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (err) {
      // Invalid URL or relative URL without base, safely ignore
    }
  });
}
